import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@monksflow/monks-ui';
import { PanelLeftIcon } from 'lucide-react';
import { toggleRail, useIsRailCollapsed } from '../../model';
import { useTranslation } from 'react-i18next';

/** Shows and hides the folder tree beside the pane. */
export function RailToggleButton() {
  const { t } = useTranslation('projects');
  const isCollapsed = useIsRailCollapsed();

  // The button carries only a glyph, so the label it answers to is also the
  // only thing that says what it does. It is the same string in both places
  // rather than two wordings for one control.
  const label = isCollapsed
    ? t('projectDetail.railToggleButton.showFolders')
    : t('projectDetail.railToggleButton.hideFolders');

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="outline"
            size="icon-lg"
            onClick={toggleRail}
            aria-pressed={!isCollapsed}
            aria-label={label}
            data-testid="approval-rail-toggle"
          >
            <PanelLeftIcon className="size-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
